import { createContext } from "react";

const PropertyFormExportContext = createContext();

export default PropertyFormExportContext;